export const LINKS = [
  {
    link: "https://youtube.com/user/snzMisty",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="48px"
        height="40px"
      >
        <path
          fill="#455A64"
          d="M14.539 6h2.125l1.37 5.496h.133l1.308-5.493h2.147l-2.458 8.036V20h-2.112v-5.703L14.539 6zM21.525 11.923c0-.784.254-1.411.759-1.874.504-.466 1.182-.7 2.035-.7.778 0 1.413.245 1.908.737.495.488.743 1.121.743 1.894v5.235c0 .866-.242 1.548-.728 2.044C25.756 19.753 25.09 20 24.235 20c-.823 0-1.477-.259-1.974-.767-.493-.508-.738-1.194-.738-2.055v-5.256H21.525zM23.455 17.368c0 .275.066.494.205.646.132.15.322.226.571.226.255 0 .454-.077.604-.234.149-.151.226-.366.226-.638v-5.522c0-.22-.079-.399-.231-.536-.151-.135-.352-.205-.599-.205-.229 0-.417.07-.561.205-.143.137-.215.316-.215.536V17.368zM33.918 9.605V20h-1.875v-1.266c-.346.414-.705.728-1.081.941C30.59 19.89 30.227 20 29.876 20c-.435 0-.76-.149-.981-.452-.221-.3-.329-.751-.329-1.357V9.605h1.874v7.886c0 .236.04.41.12.519.075.104.207.162.38.162.141 0 .315-.071.522-.215.213-.141.406-.324.581-.544V9.605H33.918z"
        />
        <path
          fill="#FFF"
          d="M38.799,26.439c0-2.342-1.94-4.24-4.329-4.24c-3.412-0.143-6.905-0.203-10.47-0.198c-3.563-0.005-7.056,0.056-10.47,0.198c-2.387,0-4.327,1.898-4.327,4.24C9.061,28.291,8.995,30.145,9,32.001c-0.005,1.853,0.06,3.707,0.204,5.561c0,2.345,1.938,4.243,4.326,4.243c3.414,0.14,6.907,0.2,10.47,0.195c3.564,0.008,7.058-0.056,10.47-0.195c2.389,0,4.329-1.898,4.329-4.243c0.142-1.854,0.209-3.708,0.201-5.561C39.008,30.145,38.941,28.291,38.799,26.439z"
        />
        <g>
          <path
            fill="#F44336"
            d="M33.851 30.346c-.219 0-.368.058-.458.18-.064.091-.145.299-.145.752v.774h1.193v-.774c0-.446-.083-.655-.151-.757C34.205 30.402 34.061 30.346 33.851 30.346zM26.865 30.386c-.086.042-.17.105-.258.193v5.876c.11.111.217.191.316.242.111.055.224.08.346.08.231 0 .303-.091.326-.123.057-.071.119-.219.119-.54v-5.005c0-.278-.053-.493-.152-.625C27.428 30.306 27.164 30.236 26.865 30.386z"
          />
          <path
            fill="#F44336"
            d="M38.799,26.439c0-2.342-1.94-4.24-4.329-4.24c-3.412-0.143-6.905-0.203-10.47-0.198c-3.563-0.005-7.056,0.056-10.47,0.198c-2.387,0-4.327,1.898-4.327,4.24C9.061,28.291,8.995,30.145,9,32.001c-0.005,1.853,0.06,3.707,0.204,5.561c0,2.345,1.938,4.243,4.326,4.243c3.414,0.14,6.907,0.2,10.47,0.195c3.564,0.008,7.058-0.056,10.47-0.195c2.389,0,4.329-1.898,4.329-4.243c0.142-1.854,0.209-3.708,0.201-5.561C39.008,30.145,38.941,28.291,38.799,26.439z M15.701,38.382c0,0.111-0.092,0.204-0.206,0.204h-2.049c-0.114,0-0.206-0.093-0.206-0.204v-11.03h-1.914c-0.113,0-0.205-0.092-0.205-0.203v-1.904c0-0.112,0.092-0.204,0.205-0.204h6.291c0.114,0,0.206,0.092,0.206,0.204v1.904c0,0.111-0.091,0.203-0.206,0.203h-1.916V38.382z M22.995,38.382c0,0.111-0.092,0.204-0.206,0.204h-1.822c-0.114,0-0.206-0.093-0.206-0.204v-0.551c-0.243,0.233-0.486,0.418-0.738,0.56c-0.397,0.227-0.776,0.336-1.16,0.336c-0.488,0-0.864-0.176-1.117-0.517c-0.238-0.324-0.361-0.803-0.361-1.421v-8.1c0-0.112,0.092-0.204,0.207-0.204h1.821c0.114,0,0.206,0.092,0.206,0.204v7.428c0,0.244,0.044,0.343,0.072,0.382c0.013,0.017,0.05,0.067,0.205,0.067c0.052,0,0.172-0.022,0.389-0.169c0.176-0.115,0.334-0.259,0.473-0.425v-7.283c0-0.112,0.092-0.204,0.207-0.204h1.821c0.114,0,0.206,0.092,0.206,0.204v9.692H22.995z M30,36.373c0,0.736-0.159,1.31-0.473,1.708c-0.326,0.418-0.797,0.626-1.398,0.626c-0.383,0-0.733-0.077-1.046-0.233c-0.166-0.083-0.327-0.191-0.479-0.325v0.233c0,0.114-0.093,0.204-0.206,0.204h-1.837c-0.114,0-0.207-0.09-0.207-0.204v-13.14c0-0.112,0.092-0.203,0.207-0.203h1.837c0.113,0,0.206,0.091,0.206,0.203v3.717c0.15-0.136,0.31-0.25,0.474-0.343c0.309-0.17,0.625-0.256,0.941-0.256c0.641,0,1.143,0.238,1.484,0.706c0.328,0.45,0.495,1.101,0.495,1.933L30,36.373L30,36.373z M36.729,33.765c0,0.113-0.093,0.205-0.207,0.205h-3.273v1.621c0,0.592,0.082,0.845,0.148,0.951c0.053,0.088,0.152,0.199,0.438,0.199c0.23,0,0.388-0.055,0.469-0.164c0.037-0.058,0.139-0.28,0.139-0.988v-0.675c0-0.114,0.093-0.204,0.207-0.204h1.872c0.114,0,0.205,0.09,0.205,0.204v0.729c0,1.044-0.249,1.844-0.737,2.384c-0.49,0.543-1.23,0.82-2.198,0.82c-0.872,0-1.574-0.296-2.079-0.871c-0.5-0.571-0.755-1.354-0.755-2.333v-4.352c0-0.892,0.278-1.63,0.83-2.196c0.55-0.568,1.274-0.857,2.144-0.857c0.89,0,1.587,0.271,2.072,0.803c0.48,0.526,0.724,1.284,0.724,2.251v2.474H36.729z"
          />
        </g>
      </svg>
    ),
  },
  {
    link: "mailto:info@mak-online.ru",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 64 64"
        width="30px"
        height="40px"
      >
        <polygon fill="#fbb553" points="8.4 20.7 8.4 30.1 2.5 25.5" />
        <path d="M64,25.5c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0l-0.1-0.1c0,0,0,0,0,0l-8.1-6.6V7.6c0-0.5-0.4-1-1-1H41.3l-5.4-4.4c-2.3-1.8-5.5-1.8-7.8,0l-5.4,4.4H9.4c-0.5,0-1,0.4-1,1v10.7l-8.1,6.6c0,0,0,0,0,0.1c0,0,0,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.2c0,0,0,0,0,0v36.6c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0.1,0.2c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0C0.4,63,0.5,63,0.6,63.1c0,0,0,0,0.1,0c0.1,0,0.2,0.1,0.3,0.1H63c0.1,0,0.2,0,0.3-0.1c0,0,0,0,0.1,0c0.1,0,0.2-0.1,0.3-0.2c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2c0,0,0,0,0-0.1L64,25.5C64,25.5,64,25.5,64,25.5z M55.6,20.7l5.9,4.8l-5.9,4.5V20.7z M29.3,3.7c1.6-1.3,3.8-1.3,5.4,0l3.5,2.9H25.8L29.3,3.7z M10.4,8.5h43.3v23L37.1,44.3H26.9L10.4,31.6V8.5z M8.4,20.7v9.3l-5.9-4.5L8.4,20.7z M1.9,27.5l22.9,17.7L1.9,60.4V27.5z M4.2,61.2l22.7-15h10.3l22.7,15H4.2z M62.1,60.4L39.1,45.2l22.9-17.7V60.4z" />
        <path
          fill="#d5d6d5"
          d="M10.4,8.5v23l16.5,12.7h10.2l16.5-12.7v-23H10.4z M47,33.4H17c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1H47c0.5,0,1,0.4,1,1C47.9,32.9,47.5,33.4,47,33.4z M47,27.3H17c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1H47c0.5,0,1,0.4,1,1C47.9,26.9,47.5,27.3,47,27.3z M47,21.2H17c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1H47c0.5,0,1,0.4,1,1C47.9,20.8,47.5,21.2,47,21.2z M47,15.2H17c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1H47c0.5,0,1,0.4,1,1C47.9,14.8,47.5,15.2,47,15.2z"
        />
        <polygon
          fill="#edeced"
          points="12.3 8.5 12.3 33.1 10.4 31.6 10.4 8.5"
        />
        <polygon
          fill="#bfbebc"
          points="51.7 8.5 51.7 33.1 53.6 31.6 53.6 8.5"
        />
        <polygon
          fill="#5acaf4"
          points="59.8 61.2 4.2 61.2 26.8 46.2 37.2 46.2"
        />
        <polygon
          fill="#36a1cf"
          points="59.8 61.2 4.2 61.2 6.1 59.9 57.9 59.9"
        />
        <polygon
          fill="#43b4dc"
          points="57.9 59.9 6.1 59.9 10.1 57.3 53.9 57.3"
        />
        <polygon fill="#5acaf4" points="62.1 27.5 62.1 60.4 39.1 45.2" />
        <polygon fill="#fbb553" points="61.5 25.5 55.6 30.1 55.6 20.7" />
        <polygon
          fill="#e8932f"
          points="61.5 25.5 60.5 26.2 55.6 22.2 55.6 20.7"
        />
        <polygon
          fill="#f1a444"
          points="60.5 26.2 58.9 27.5 55.6 24.8 55.6 22.2"
        />
        <polygon fill="#e8932f" points="2.5 25.5 3.4 26.2 8.4 22.2 8.4 20.7" />
        <polygon fill="#f1a444" points="3.4 26.2 5.1 27.5 8.4 24.8 8.4 22.2" />
        <polygon fill="#5acaf4" points="24.9 45.2 1.9 60.4 1.9 27.5" />
        <polygon fill="#36a1cf" points="3.5 28.7 3.5 59.4 1.9 60.4 1.9 27.5" />
        <polygon fill="#43b4dc" points="7.2 31.5 7.2 56.9 3.5 59.4 3.5 28.7" />
        <polygon
          fill="#36a1cf"
          points="60.5 28.7 60.5 59.4 62.1 60.4 62.1 27.5"
        />
        <polygon
          fill="#43b4dc"
          points="56.8 31.5 56.8 56.9 60.5 59.4 60.5 28.7"
        />
        <path
          fill="#fbb553"
          d="M38.2,6.6H25.8l3.5-2.9c1.6-1.3,3.8-1.3,5.4,0L38.2,6.6z"
        />
        <path
          fill="#e8932f"
          d="M38.2,6.6H37l-2.4-1.9c-1.5-1.3-3.8-1.3-5.3,0L27,6.6h-1.2l3.5-2.9c1.6-1.3,3.8-1.3,5.4,0L38.2,6.6z"
        />
        <path
          fill="#f1a444"
          d="M37,6.6h-2l-0.4-0.3c-1.6-1.3-3.8-1.3-5.4,0L29,6.6h-2l2.3-1.9c1.6-1.3,3.8-1.3,5.3,0L37,6.6z"
        />
        <path d="M47.9 14.2c0 .5-.4 1-1 1H17c-.5 0-1-.4-1-1 0-.5.4-1 1-1H47C47.5 13.2 47.9 13.7 47.9 14.2zM47.9 20.3c0 .5-.4 1-1 1H17c-.5 0-1-.4-1-1 0-.5.4-1 1-1H47C47.5 19.3 47.9 19.7 47.9 20.3zM47.9 26.3c0 .5-.4 1-1 1H17c-.5 0-1-.4-1-1 0-.5.4-1 1-1H47C47.5 25.4 47.9 25.8 47.9 26.3zM47.9 32.4c0 .5-.4 1-1 1H17c-.5 0-1-.4-1-1 0-.5.4-1 1-1H47C47.5 31.4 47.9 31.8 47.9 32.4z" />
      </svg>
    ),
  },
  {
    link: "https://api.whatsapp.com/send?phone=79191175599",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="45px"
        height="40px"
        fillRule="evenodd"
        clipRule="evenodd"
      >
        <path
          fill="#fff"
          d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"
        />
        <path
          fill="#fff"
          d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"
        />
        <path
          fill="#cfd8dc"
          d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"
        />
        <path
          fill="#40c351"
          d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"
          clipRule="evenodd"
        />
      </svg>
    ),
  },
  {
    link: "https://telegram.me/+79191175599",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="34px"
        height="40px"
      >
        <path fill="#29b6f6" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z" />
        <path
          fill="#fff"
          d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z"
        />
        <path
          fill="#b0bec5"
          d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z"
        />
        <path
          fill="#cfd8dc"
          d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z"
        />
      </svg>
    ),
  },
  {
    link: "tel:+79191175599",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 38"
      >
        <g transform="translate(1.4065934065934016 1.4065934065934016) scale(0.3 0.3)">
          <path
            d="M 90 49.5 h -9 C 81 27.168 62.832 9 40.5 9 V 0 C 67.794 0 90 22.206 90 49.5 z"
            fill="rgb(38,185,153)"
            transform=" matrix(1 0 0 1 0 0) "
            strokeLinecap="round"
          />
          <path
            d="M 72.5 49.5 h -9 c 0 -12.682 -10.317 -23 -23 -23 v -9 C 58.145 17.5 72.5 31.855 72.5 49.5 z"
            fill=" rgb(38,185,153)"
            transform=" matrix(1 0 0 1 0 0) "
            strokeLinecap="round"
          />
          <path
            d="M 49.665 62.087 c 0.974 0.974 2.471 1.194 3.684 0.543 l 6.198 -3.328 c 11.764 2.454 21.211 7.851 28.004 16.618 c 0.016 -0.038 0.032 -0.074 0.049 -0.112 c -1.393 3.212 -2.871 6.667 -3.621 8.581 c -0.247 0.631 -0.615 1.208 -1.127 1.652 c -12.674 10.986 -37.89 -2.4 -57.191 -21.701 C 6.358 45.039 -7.028 19.823 3.958 7.149 c 0.444 -0.512 1.022 -0.88 1.652 -1.127 c 1.914 -0.75 5.369 -2.228 8.581 -3.621 c -0.038 0.016 -0.074 0.032 -0.112 0.049 c 8.767 6.793 14.164 16.24 16.618 28.004 l -3.328 6.198 c -0.651 1.213 -0.431 2.71 0.543 3.684 l 10.876 10.876 L 49.665 62.087 z"
            fill="rgb(105,188,69)"
            transform=" matrix(1 0 0 1 0 0) "
            strokeLinecap="round"
          />
          <path
            d="M 59.547 59.302 l 6.835 -3.669 c 0.964 -0.518 2.129 -0.493 3.07 0.066 l 19.017 11.285 c 1.357 0.805 1.903 2.489 1.268 3.933 c -0.599 1.363 -1.38 3.146 -2.185 5.003 L 59.547 59.302 z"
            fill="rgb(71,160,71)"
            transform=" matrix(1 0 0 1 0 0) "
            strokeLinecap="round"
          />
          <path
            d="M 30.698 30.453 l 3.669 -6.835 c 0.518 -0.964 0.493 -2.129 -0.066 -3.07 L 23.017 1.531 c -0.805 -1.357 -2.489 -1.903 -3.933 -1.268 c -1.363 0.599 -3.146 1.38 -5.003 2.185 L 30.698 30.453 z"
            fill="rgb(71,160,71)"
            transform=" matrix(1 0 0 1 0 0) "
            strokeLinecap="round"
          />
        </g>
      </svg>
    ),
  },
];
